import styled, { css } from "styled-components";
import { DesignTokens } from "../../../styles/design-tokens";
import { ColorSwatch, ColorSwatchProps } from "./ColorSwatch";

const { spacings, colors, fonts } = DesignTokens;

type LabelSize = "xlarge" | "large" | "base" | "small" | "superSmall";

const StyledColorSwatchLabel = styled.div<{
  isGrayedOut: boolean;
  size?: LabelSize;
}>`
  margin-left: ${spacings.small}px;
  font-size: ${({ size }) => fonts.sizes[size ?? "base"]}px;

  ${({ isGrayedOut }) => css`
    ${isGrayedOut && `color: ${colors.gray.middle}`};
  `}
`;

const StyledColorSwatchWrapper = styled.div`
  display: flex;
  align-items: center;
`;

type LabeledColorSwatchProps = {
  label: React.ReactNode;
  labelSize?: LabelSize;
};

const LabeledColorSwatch: React.FC<
  LabeledColorSwatchProps & ColorSwatchProps
> = ({ argb, label, labelSize, ...rest }) => (
  <StyledColorSwatchWrapper>
    <ColorSwatch {...rest} argb={argb} />
    <StyledColorSwatchLabel isGrayedOut={!argb} size={labelSize}>
      {label}
    </StyledColorSwatchLabel>
  </StyledColorSwatchWrapper>
);

export { LabeledColorSwatch };
